// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g8BAo","toggleWrap":"styles_toggleWrap__3TfsE","content":"styles_content__3NPgA","selectAreaCode":"styles_selectAreaCode__3wij0"};